import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { fetchFeatureFlagStates } from "api/featureFlags";
import featureFlagQueries from "queries/featureFlag";

// Maintain a static list of feature flag names to be resolved for Admin.
export const FEATURE_FLAGS: readonly string[] = Object.freeze([]);

const useFeatureFlags = ({
  queryClient,
}: { queryClient?: QueryClient } = {}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const qc = queryClient ?? useQueryClient();

  const flagNames = [...FEATURE_FLAGS];
  const featureFlagQuery = {
    queryKey: featureFlagQueries.states(flagNames),
    queryFn: () => fetchFeatureFlagStates(flagNames),
    staleTime: Infinity,
  };

  const initialize = async () => qc.prefetchQuery(featureFlagQuery);

  const isEnabled = async (flagName: string) => {
    const featureFlags = await qc.fetchQuery(featureFlagQuery);
    return !!featureFlags[flagName];
  };

  return { initialize, isEnabled };
};

export default useFeatureFlags;
